module.exports = __webpack_public_path__ + "static/media/PeruRaulbello.2ba070a2.webp";